import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { accountAlertProfile } from '../site-config';
import { TokenInterceptor } from './token-interceptor';

/**
 * Release builds ask the account API for production's alert settings
 * (site-config accountAlerts), so staging shows the same account as
 * www even though it talks to the DEV2 API. Only /account calls to the
 * PlateX API carry the header; DEV2 sends nothing and gets the API default.
 */
@Injectable()
export class AccountProfileInterceptor implements HttpInterceptor {
  public static readonly HEADER = 'X-Account-Profile';

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!accountAlertProfile || !/\/account(\/|\?|$)/.test(request.url) || !TokenInterceptor.isApiUrl(request.url)) {
      return next.handle(request);
    }
    return next.handle(request.clone({ setHeaders: { [AccountProfileInterceptor.HEADER]: accountAlertProfile } }));
  }
}
